export default (function (value) {
  return value === undefined;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-actions/es/utils/isUndefined.js
// module id = ./node_modules/redux-actions/es/utils/isUndefined.js
// module chunks = 6 9 11